export const MAP_ANNOTATIONS_SLICE_NAME = 'mapAnnotations' as const;
